import * as Config from '../../../config';
import { useEffect} from 'react';
import { connect, useDispatch } from 'react-redux';
import { addHistoryTracks, addReplayTracks, setOnAir  } from "../../../actions/index";

import useSocketPM from './hooks/useSocketPM';

// Communication Player <=> Library - Party Mode Requests
function ConnectedPartyModeWrapper({
  api, user, socket, requestPM, playerMessagePM,
  isOutsider, isSubscribed,
  broadcastAudio, audioInfosPM,
  room
}) {
  const dispatch = useDispatch();

  // Init Server <=> Client
  useSocketPM(user, isOutsider);

  // Song Request From The Player
  useEffect(() => {
    if (requestPM && requestPM.deck && requestPM.track && room) {
      api.getFromApi(`/catalog/tracks/${requestPM.track}/`, false).then( response => {
        const track = [response.data].map(Config.formattedFromBP).shift();
        if (track) {
          dispatch(addHistoryTracks({ ...track, selected: false }));
          dispatch(addReplayTracks(track.id));
          dispatch(setOnAir(requestPM.deck, track.id));
          if (isSubscribed) {
            api.loadAudio(requestPM.deck, track, true, track.is_available_for_streaming, false); // Autoload ?
          } else if (!isSubscribed && audioInfosPM) {
            // For no subscriber with the broadcast infos. Right now with the actual jquery version, on first load we cannot get the right infos
            api.loadAudioUrl(requestPM.deck, track, audioInfosPM.url);
          } else if (!isSubscribed) { //FIRST LOAD - Server Solution
            const requestedTrack = (room.deckTracks && room.deckTracks[requestPM.deck]) ? room.deckTracks[requestPM.deck] : null;
            if (requestedTrack && parseInt(requestedTrack.id) === parseInt(requestPM.track)) {
              api.loadAudioUrl(requestPM.deck, requestedTrack, requestedTrack.url);
            }
          }
        }
      }).catch( e => { // For no subscribers + restricted territory
        if (audioInfosPM && parseInt(audioInfosPM.id) === parseInt(requestPM.track)) {
          // console.log(`**DJAPP** DIRECT LOAD ${requestPM.deck} RT`);
          api.loadAudioUrl(requestPM.deck, audioInfosPM, audioInfosPM.url);
        } else if (!audioInfosPM && room.deckTracks) {
          // console.log(`**DJAPP** FIRST LOAD ${requestPM.deck} RT`);
          const requestedTrack = (room.deckTracks && room.deckTracks[requestPM.deck]) ? room.deckTracks[requestPM.deck] : null;
          if (requestedTrack && parseInt(requestedTrack.id) === parseInt(requestPM.track)) {
            api.loadAudioUrl(requestPM.deck, requestedTrack, requestedTrack.url);
          }
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, requestPM, isSubscribed, room, dispatch])

  useEffect(() => {
    if (socket && broadcastAudio) {
      socket.emit("broadcast audio infos", broadcastAudio);
    }
  }, [socket, broadcastAudio])

  return null;
}

const PartyModeWrapper = connect(
  state => ({
    api: state.api,
    user: state.user,
    socket: state.socketPM,
    requestPM: state.requestPM,
    isSubscribed: state.isSubscribed,
    isOutsider: state.isOutsider,
    broadcastAudio: state.broadcastAudio,
    audioInfosPM: state.audioInfosPM,
    room: state.inRoomPM
  })
)(ConnectedPartyModeWrapper);

export default PartyModeWrapper;
